/* eslint no-shadow: 0 */
export enum AssessmentsKind {
  YES_NO = 0,
  TEXT_FIELD = 1,
  STAR_RATING = 2,
}
